export default __webpack_public_path__ + "static/media/JobshubLogo.739edba0.svg";